import { Box } from "@mui/material";
import React from "react";

import { SidebarMenu } from "@/components/sidebar/menu/SidebarMenu";
import { sidebarTheme } from "@/styles/sidebarTheme";

import { SidebarLogoBox } from "./SidebarLogoBox";
import { SidebarLogoutButton } from "./SidebarLogoutButton";

interface SidebarDrawerContentProps {
  actualDrawerWidth: number;
  onMenuItemClick?: () => void;
}

export const SidebarDrawerContent: React.FC<SidebarDrawerContentProps> = ({
  actualDrawerWidth,
  onMenuItemClick,
}) => {
  return (
    <Box
      sx={{
        textAlign: "left",
        height: "100%",
        background: sidebarTheme.background.main,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: actualDrawerWidth,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <SidebarLogoBox />

      {/* Scrollable menu area */}
      <Box
        sx={{
          flex: 1,
          width: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: sidebarTheme.background.scrollbarThumb,
            borderRadius: "3px",
          },
        }}
      >
        <SidebarMenu onMenuItemClick={onMenuItemClick} />
      </Box>

      {/* Fixed logout button at bottom */}
      <SidebarLogoutButton onMenuItemClick={onMenuItemClick} />
    </Box>
  );
};
